import { IonToolbar, IonButtons, IonTitle, IonBackButton, IonPage, IonContent } from "@ionic/react";
import { useParams } from "react-router-dom";
import { UploadDocument } from "./UploadNewDocumentScreen";
import { useSelector } from "react-redux";
import { selectUser } from "../../../store/userAuthentication/selectors/selectUser";

export const SupervisorNewDocumentUpload = () => {
  const { userId }: { userId: string } = useParams();
  const { from } : { from: string } = useParams();

  const user = useSelector(selectUser);

  return (
    <>
      <IonPage>
        <IonContent>
          <IonToolbar>
            <IonButtons slot="start">
              <IonBackButton color="light" defaultHref={`/app/supervision/colaborador/${userId}`} />
            </IonButtons>
            <IonTitle>Subir Documento</IonTitle>
          </IonToolbar>
          <section className="ion-padding">
            <UploadDocument userId={userId} ownerId={user?.id!} isFrom={from} />
          </section>
        </IonContent>
      </IonPage>
    </>
  );
};
